import {
  ComponentClusterView,
  ComponentView,
  StatusCountStatusEnum,
  ViewComponentResponse,
} from '@cast/types-cluster-management';

export const generateClusterManagementComponent = (
  mockComponent: Partial<ComponentView> = {},
  mockClusters?: ComponentClusterView[]
): ViewComponentResponse => {
  return {
    component: {
      id: 'component-id-ai-optimizer-proxy',
      name: 'pod-mutator',
      descriptionTitle: 'Cost optimization',
      description:
        'Automatically transforms pod specifications at creation time using configurable templates, enabling consistent resource allocation, bulk label modifications, and seamless workload migrations without changing deployment manifests.',
      pricingType: 'PAID',
      latestVersion: '0.0.16',
      clusterCount: 0,
      statuses: [{ status: StatusCountStatusEnum.WARNING, count: 1 }],
      featureId: '49909b64-67ee-4929-aa03-63308458c85f',
      supportedProviders: ['AKS', 'EKS', 'GKE'],
      ...mockComponent,
    },
    clusters: mockClusters ?? [
      {
        id: 'cluster-1-id',
        name: 'test1',
        cloudAccountId: 'test1',
        manager: 'CONSOLE',
        usedVersion: '0.0.16',
        status: 'ACTION_REQUIRED',
        action: 'UPDATE',
      },
      {
        id: 'cluster-2-id',
        name: 'test2',
        cloudAccountId: 'test2',
        manager: 'TERRAFORM',
        usedVersion: '0.0.16',
        status: 'ERROR',
        action: 'FIX',
      },
      {
        id: 'cluster-3-id',
        name: 'test3',
        cloudAccountId: 'test3',
        manager: 'MANAGER_UNSPECIFIED',
        usedVersion: '',
        status: 'DISCONNECTED',
        action: 'ENABLE',
      },
      {
        id: 'cluster-4-id',
        name: 'test4',
        cloudAccountId: 'test4',
        manager: 'CONSOLE',
        usedVersion: '0.0.15',
        status: 'OK',
        action: 'ACTION_UNSPECIFIED',
      },
    ],
  };
};
